import script from "./StandardOutputValidation.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardOutputValidation.vue?vue&type=script&setup=true&lang=js"

import "./StandardOutputValidation.vue?vue&type=style&index=0&id=0f1ad720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1ad720"]])

export default __exports__